(ns journal-app-client.utils.visibility
  (:require [goog.object :as g]))

(defonce hidden? (atom false))
(defonce hidden (atom nil))
(defonce change (atom nil))

(defn handle-change []
  (if (g/get js/document @hidden)
    (do (reset! hidden? true)
        #_(println "Hidden!"))
    (do (reset! hidden? false)
        #_(println "Not hidden!"))))

(defn add-listener []
  (cond
    (exists? js/document.hidden)
    (do (reset! hidden "hidden")
        (reset! change "visibilitychange"))

    (exists? js/document.msHidden)
    (do (reset! hidden "msHidden")
        (reset! change "msvisibilitychange"))

    (exists? js/document.webkitHidden)
    (do (reset! hidden "webkitHidden")
        (reset! change "webkitvisibilitychange")))
  (when @change
    (js/window.addEventListener @change handle-change)))